import PropTypes from 'prop-types';
import React from 'react';
import Image from 'next/image';
import Smartlook from 'smartlook-client';
import { EmailShareButton, FacebookShareButton, TwitterShareButton, WhatsappShareButton } from 'react-share';
import { IC_SHARE_FACEBOOK, IC_SHARE_MAIL, IC_SHARE_TWITTER, IC_SHARE_WHATSAPP } from '@common/Assets/images';
import useScrollHandler from '@common/Context/useScrollHandler';
import useWindowDimensions from '@common/Context/useWindowDimensions';
import { dataLayerSendEvent } from '../EpharmacyAnalytics';
import { useTranslation } from '@common/i18n';

const ShareProduct = ({
  productName,
  shareUrl,
  shareBy,
  productType,
  productSku,
  brand,
  productCategory,
  detailsData,
  isHomeCarePage,
  pageType = ' ',
  currency = ' ',
  value = ' ',
  serviceType = ' ',
  screenName = ' ',
  doctorName= '',
  isFromDoctor= false,
  facilityName= '',
  isFromFacility= false,
  referralData,
  couponCode,
  isFromRecords,
  PromotionLeafLet,
}) => {
  const t = useTranslation();

  const getQuote = () => {
    if (serviceType === 'Package') {
      return `Check out ${productName}. package on myAster `;
    }
    if (isFromDoctor) {
      return `Learn more about ${doctorName} qualifications, specializations and available slots on myAster. `;
    }
    if (isFromFacility){
      return `Learn more about ${facilityName}, check available doctors and services on myAster. `
    }
    if (referralData) {
      return `Hey, I’m sharing an exclusive invite to myAster with you. Using my referral code "${couponCode}" and earn AED ${referralData?.referredAmount} per referral. `;
    }
    if (PromotionLeafLet){
      return `Check out this promotion leaflet on myAster! `
    }
    return 'I like this product in myAster App, you can check the product on this link ';
  };

  const shareProductDetailsMetaData = {
    quote: getQuote(),
  };

  const onShareButtonClick = (shareBy) => {
    if (isHomeCarePage) {
      sendShareEvent(detailsData, shareBy);
      if (serviceType === 'Package') {
        dataLayerSendEvent('share_product_details', {
          product_name: productName,
          share_by: shareBy,
          currency,
          value,
          service_type: serviceType,
          product_type: productType,
          screen_name: screenName,
          page_type: pageType,
        });
        Smartlook.track('share_product_details', {
          product_name: productName,
          share_by: shareBy,
          service_type: serviceType,
          product_type: productType,
          screen_name: screenName,
          page_type: pageType,
        });
      } else {
        dataLayerSendEvent('share_product_details', {
          shareBy,
          product_type: productType,
          product_sku: productSku,
          productName,
          brand,
          productCategory,
        });
      }
    }
  };

  const scrollY = useScrollHandler();
  const { height } = useWindowDimensions();

  return (
    <div className={scrollY >= height / 2  && !isFromRecords? 'filterBox' : 'filterBox '}>
      {/** in above div add openup class if want to open above. as per bug, removing this class. */}
      <div className="box">
        <div className="title">
          <FacebookShareButton
            data-test="facebook"
            onClick={() => {
              onShareButtonClick('Facebook');
            }}
            url={shareUrl || window?.location?.href}
            quote={shareProductDetailsMetaData?.quote}
          >
            <Image src={IC_SHARE_FACEBOOK.src} alt="Product Share" width="36px" height="36px" /> {t('ProductDetail.facebook')}
          </FacebookShareButton>
        </div>
      </div>
      <div className="box">
        <div className="title">
          <TwitterShareButton
            data-test="twitter"
            onClick={() => {
              onShareButtonClick('Twitter');
            }}
            url={shareUrl || window?.location?.href}
            title={shareProductDetailsMetaData?.quote}
          >
            <Image src={IC_SHARE_TWITTER.src} alt="Product Share" width="36px" height="36px" /> {t('ProductDetail.twitter')}
          </TwitterShareButton>
        </div>
      </div>
      <div className="box">
        <div
          className="title"
          data-test="email"
          onClick={() => {
            onShareButtonClick('Email');
          }}
        >
          <EmailShareButton
            url={shareUrl || window?.location?.href}
            subject={ !isFromDoctor && !isFromFacility ? `Buy ${productName} on myAster` : ''}
            body={shareProductDetailsMetaData?.quote}
          >
            <Image src={IC_SHARE_MAIL.src} alt="Product Share" width="36px" height="36px" /> {t('ProductDetail.email')}
          </EmailShareButton>
        </div>
      </div>
      <div className="box">
        <div className="title">
          <WhatsappShareButton
            data-test="whatsApp"
            onClick={() => {
              onShareButtonClick('WhatsApp');
            }}
            url={shareUrl || shareProductDetailsMetaData?.quote + window?.location?.href}
          >
            <Image src={IC_SHARE_WHATSAPP.src} alt="Product Share" width="36px" height="36px" /> {t('ProductDetail.whatsapp')}
          </WhatsappShareButton>
        </div>
      </div>
    </div>
  );
};

ShareProduct.propTypes = {
  productName: PropTypes.string,
  shareUrl: PropTypes.string,
  shareBy: PropTypes.string,
  productSku: PropTypes.string,
  productType: PropTypes.string,
  brand: PropTypes.string,
  productCategory: PropTypes.string,
  detailsData: PropTypes.object,
  isHomeCarePage: PropTypes.bool,
  currency: PropTypes.string,
  value: PropTypes.number,
  serviceType: PropTypes.string,
  pageType: PropTypes.string,
  screenName: PropTypes.string,
  doctorName: PropTypes.string,
  isFromDoctor: PropTypes.bool,
  isFromFacility: PropTypes.bool,
  facilityName: PropTypes.string,
  referralData: PropTypes.string,
  couponCode: PropTypes.string,
};

export default ShareProduct;
